import { render, staticRenderFns } from "./customer-orders-table.vue?vue&type=template&id=b15d28ac&"
import script from "./customer-orders-table.vue?vue&type=script&lang=ts&"
export * from "./customer-orders-table.vue?vue&type=script&lang=ts&"
import style0 from "./customer-orders-table.vue?vue&type=style&index=0&id=b15d28ac&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports